import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, QuotationData, CustomerQuotation, CountData, RejectData } from './types'

export const selectQuotationListEvent = (state: RootState): Event => state.quotationReducer.listEvent

export const selectQuotationList = (state: RootState): ListData => state.quotationReducer.list

export const selectQuotationActionEvent = (state: RootState): Event => state.quotationReducer.actionEvent

export const selectQuotationDetail = (state: RootState): QuotationData | undefined =>
  state.quotationReducer.detail

export const selectQuotationDetailEvent = (state: RootState): Event => state.quotationReducer.detailEvent

export const selectCustomersEvent = (state: RootState): Event => state.quotationReducer.customersEvent

export const selectCustomers = (state: RootState): CustomerQuotation[] => state.quotationReducer.customers

export const selectGrnEvent = (state: RootState): Event => state.quotationReducer.grnEvent

export const selectQuotationCountData = (state: RootState): CountData | undefined =>
  state.quotationReducer.countData

export const selectRejectData = (state: RootState): RejectData | undefined =>
  state.quotationReducer.rejectData
